import React, { useState, useEffect } from "react";
import "./Tab.scss";
import CommentSection from "../CommentSection/CommentSection";

const TabComponent = ({ info, reload, setReload }) => {
  const [activeButton, setActiveButton] = useState("description");
  const [descriptionText, setDescriptionText] = useState([]);
  const [specificationsText, setSpecificationsText] = useState([]);
  const [showCommentForm, setShowCommentForm] = useState(false);
  const [showStarRating, setShowStarRating] = useState(true);

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
    setShowCommentForm(false); // Hide the comment section when switching buttons

    if (buttonName === "description") {
      // Simulating backend data for description
      setDescriptionText(sampleData.description);
      setSpecificationsText([]); // Clear specifications text
    } else if (buttonName === "specifications") {
      // Simulating backend data for specifications
      setSpecificationsText(sampleData.specification);
      setDescriptionText([]); // Clear description text
    } else if (buttonName === "comments") {

      // console.log(`commentssssss::`,info)
      setShowCommentForm(true);
      setDescriptionText([]); // Clear description text
      setSpecificationsText([]); // Clear specifications text
    }
  };

  // Sample data
  const sampleData = {
    description: [
      { Titel: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ" },
      {
        descriptions:
          "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
      },
      { Titel: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ" },
      {
        descriptions:
          "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
      },
    ],
    specification: [
      {
        Titel: "ویژگی 1",
        specifications:
          "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ",
      },
      { Titel: "ویژگی 2", specifications: "لورم ایپسوم متن ساختگی" },
      {
        Titel: "ویژگی 3",
        specifications: "لورم ایپسوم متن ساختگی با تولید سادگی",
      },
      { Titel: "ویژگی 4", specifications: "لورم ایپسوم" },
      { Titel: "ویژگی 5", specifications: "لورم ایپسوم متن ساختگی" },
      {
        Titel: "ویژگی 6",
        specifications:
          "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ",
      },
    ],
  };

  useEffect(() => {
    // Load description data by default
    setDescriptionText(sampleData.description);
    setSpecificationsText([]);
    setShowCommentForm(false);
  }, []);
  let productText =
    info?.description && info?.description?.replace(/\n/g, "<br>");

  return (
    <div className="TabProduct responsive_mrg">
      <div className="btns">
        <button
          className={`btn ${activeButton === "description" ? "active" : ""}`}
          onClick={() => handleButtonClick("description")}
        >
          توضیحات
        </button>
        <button
          className={`btn ${activeButton === "specifications" ? "active" : ""}`}
          onClick={() => handleButtonClick("specifications")}
        >
          مشخصات
        </button>
        <button
          className={`btn ${activeButton === "comments" ? "active" : ""}`}
          onClick={() => handleButtonClick("comments")}
        >
          نظرات
        </button>
      </div>
      <div className="ParentCardTab">
        <div className="card">
          {activeButton === "description" && (
            <div className="description">
              {/* <p>{info?.description}</p> */}
              <p dangerouslySetInnerHTML={{ __html: productText }} />
            </div>
          )}
          {activeButton === "specifications" && (
            <div className="specifications">
              {info?.features.map((item, index) => (
                <div
                  className={`rowspecifications ${
                    index % 2 === 0 ? "even" : "odd"
                  }`}
                  key={index}
                >
                  <h5>{item.key}</h5>
                  <span>{item.value}</span>
                </div>
              ))}
            </div>
          )}
          {showCommentForm && (
            <CommentSection
              showStarRating={showStarRating}
              detailBlog={info}
              blogId={info?.id}
              reload={reload}
              setReload={setReload}
              type={2}
            /> // Pass the showStarRating state as a prop
          )}
        </div>
      </div>
    </div>
  );
};

export default TabComponent;
